import {Directive, ElementRef, HostListener, Input, OnDestroy, Renderer2} from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[tooltip]'
})
export class ExgTooltipDirective implements OnDestroy{
  private staticDiv: HTMLDivElement | undefined;
  private showTimeout: any;
  private hideTimeout: any;

  @Input() tooltip = '';
  @Input() flow = 'down';

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.createBodyDiv();
  }

  createBodyDiv(): void {
    this.staticDiv = this.renderer.createElement('div');
    this.renderer.addClass(this.staticDiv, 'tooltip-div');
    this.renderer.appendChild(document.body, this.staticDiv);
  }

  @HostListener('mouseenter', ['$event'])

  onMouseEnter(event: MouseEvent): void {
  if (this.tooltip && this.tooltip.length > 0) {
    this.showTimeout = setTimeout(() => {
        const rect = this.el.nativeElement.getBoundingClientRect();
        let offsetX = rect.left + rect.width / 2 + window.scrollX;
        let offsetY = rect.top + rect.height / 2 + window.scrollY;

        if (this.flow === 'up'){
          offsetY = rect.top + window.scrollY;
        }
        if (this.flow === 'down'){
          offsetY = rect.top + rect.height + window.scrollY;
        }
        if (this.flow === 'left'){
          offsetX = rect.left  + window.scrollX;
        }
        if (this.flow === 'right'){
          offsetX = rect.left + rect.width + window.scrollX;
        }
        this.renderer.setProperty(this.staticDiv, 'textContent', this.tooltip);
        this.renderer.setStyle(this.staticDiv, 'left', `${offsetX}px`);
        this.renderer.setStyle(this.staticDiv, 'top', `${offsetY}px`);
        this.renderer.setStyle(this.staticDiv, 'display', 'block');
        this.renderer.setAttribute(this.staticDiv, 'flow', this.flow);

        clearTimeout(this.hideTimeout);
        this.hideTimeout = setTimeout(() => {
          this.renderer.setStyle(this.staticDiv, 'display', 'none');
        }, 2500);
      }, 300);
    }
  }

  @HostListener('mouseleave', ['$event'])
  onMouseLeave(event: MouseEvent): void {
    clearTimeout(this.showTimeout);
    clearTimeout(this.hideTimeout);
    this.renderer.setStyle(this.staticDiv, 'display', 'none');
  }

  ngOnDestroy(): void {
    this.renderer.removeChild(document.body, this.staticDiv);
  }
}
